import React, { Component } from "react";
import { AxiosResponse, AxiosError } from "axios";
import NumberFormat from "react-number-format";
import { HeroesResource } from "../../../../stores/LeaderboardStore/Types";
import { Api } from "../../../../utils/Api";

interface Props {
  heroes: HeroesResource;
  totalHeroes: number;
  prevPage: (page: number) => number;
  nextPage: (page: number, total_pages) => number;
}

interface State {
  heroes: HeroesResource;
  topThreeHeroes: HeroesResource;
  totalHeroes: number;
  page: number;
  loading: boolean;
}

class Heroes extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      heroes: [],
      topThreeHeroes: [],
      totalHeroes: 0,
      page: 0,
      loading: false
    };
  }

  componentDidMount() {
    const { heroes, totalHeroes } = this.props;

    this.setState({
      heroes: heroes.slice(3, 10),
      topThreeHeroes: heroes.slice(0, 3),
      totalHeroes
    });
  }

  loadPrev = event => {
    const { page } = this.state;
    const newPage = this.props.prevPage(page);

    this.getHeroes(newPage);
  };

  loadNext = event => {
    const { page, totalHeroes } = this.state;
    const nextPageNum = this.props.nextPage(page, totalHeroes);
    const newPage = nextPageNum === totalHeroes ? totalHeroes - 1 : nextPageNum;

    this.getHeroes(newPage);
  };

  getHeroes = (newPage: number) => {
    const { page, totalHeroes } = this.state;

    const client = new Api({});

    if (totalHeroes > page) {
      this.setState({ loading: true });
      client
        .get<any>(`/api/leaderboards/heroes.json?page=${newPage + 1}`)
        .then((response: AxiosResponse<any>) => {
          const { data } = response;
          this.setState({
            heroes: data.heroes,
            page: newPage,
            loading: false
          });
        })
        .catch((error: AxiosError) => {
          console.error(error.response?.statusText);
        });
    }
  };

  render() {
    const { heroes, page, topThreeHeroes, loading } = this.state;
    return (
      <div className="leaderboard-card">
        <h3 className="card-header">Top Learners</h3>

        <div className="top-three heroes">
          {loading && <div className="ui big active loader" />}
          {topThreeHeroes.map((hero, idx) => (
            <div
              className={`large_column_classes leading-position-${idx}`}
              key={idx}
            >
              <div className="user">
                <div className="leaderboard-img-wrapper">
                  <div className="leaderboard-img">
                    <div className="image-wrap">
                      <img src={hero.picture_url} />
                    </div>
                  </div>
                  <div className="position">
                    <span className={`position-${idx}`}>{idx + 1}</span>
                  </div>
                </div>
                <div className="name">{hero.protected_name}</div>
                <div className="score">
                  <NumberFormat
                    value={hero.xp}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  <span className="score-label">XP</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bottom-seven">
          {heroes.map((hero, idx) => (
            <div className="small_column_classes" key={idx}>
              <div className="user">
                <span className="position">{idx + 4 + page * 7}.</span>
                <span className="leaderboard-img">
                  <img src={hero.picture_url} />
                </span>
                <span className="name">{hero.protected_name}</span>
                <span className="score">
                  <NumberFormat
                    value={hero.xp}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  <span className="score-label">XP</span>
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-buttons">
          <button
            className="circular ui icon button next"
            onClick={e => this.loadPrev(e)}
          >
            <i className="icon angle left"></i>
          </button>
          <button
            className="circular ui icon button next"
            onClick={e => this.loadNext(e)}
          >
            <i className="icon angle right"></i>
          </button>
        </div>
      </div>
    );
  }
}

export default Heroes;
